import CampaignMappingFieldPagingResultModelBase from '../_generated/modelBases/campaign-mapping-field-paging-result-model-base';

export default class CampaignMappingFieldPagingResultModel extends CampaignMappingFieldPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
